import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SectionSubHeader from "../sectionSubHeader";
import SectionHeader from "../sectionHeader";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

const Event = () => {
  return (
    <div className="event volto-section">
      <Container className="" >
      <SectionHeader mainText1="EVENTS"  />
        <Row>
          <Col lg={9}>
           
            <SectionSubHeader headerText="Check Out Our Latest Corporate Social Responsibility Activities" />
           
          </Col>
          <Col lg={3}> 
          <p>Our Moments of Joy Celebrating the smiles we create together.</p>
          </Col>
        </Row>
        <Row className="gallery">
          <Col lg={3} md={6}>
          <img src="./images/gallery1.png" alt="Gallery 1" />
          <h3>Tiruppur</h3>
          <h4>Tamilnadu, India</h4>
          </Col>
          <Col lg={3} md={6}>
          <img src="./images/gallery2.png" alt="Gallery 1" />
          <h3>Tiruppur</h3>
          <h4>Tamilnadu, India</h4>
          </Col>
          <Col lg={3} md={6}>
          <img src="./images/gallery3.png" alt="Gallery 1" />
          <h3>Dindigul</h3>
          <h4>Tamilnadu, India</h4>
          </Col>
          <Col lg={3} md={6}>
          <img src="./images/gallery4.png" alt="Gallery 1" />
          <h3>Dindigul</h3>
          <h4>Tamilnadu, India</h4>
          </Col>
        </Row>
      </Container>
       
    </div>
  );
};

export default Event;
